<template>
  <CContainer fluid>
    <h3>Comerciales</h3>
    <CCard class="mt-4">
      <CCardBody>
        <CRow>
          <CCol col="6">
            <CInput 
              label="Buscar:" 
              addLabelClasses="text-muted font-weight-bold"
              :value.sync="searchWord" 
              @keyup.enter="getData(1, searchWord)">
              <template #prepend-content>
                <a href="#" @click="getData(1)">
                  <i class="bi bi-arrow-clockwise"></i>
                </a>
              </template>
              <template #append-content>
                <a href="#" @click="getData(1, searchWord)">
                  <i class="bi bi-search"></i>
                </a>
              </template>
            </CInput>
          </CCol>
        </CRow>
                <CDataTable
                  hover
                  :responsive=true
                  :items="sellers"
                  :fields="fields"
                  :items-per-page="itemsPerPage"
                  @row-clicked="(item, index, _columnName, e) => {
                    e.stopPropagation();
                    // goTo(item, 'detalle');
                  }">
                  <template #avatar="{item}">
                    <td :key="uuid.v1()">
                    <!-- <td :key="uuid.v1()" style="border-top: none;"> -->
                      <div class="c-avatar c-avatar-stack c-avatar-xl">
                        <img v-if="!item.urlImagenFoto" :src="getUrlImg(pathPhotoFile(item.id_Personal))" block class="c-avatar-img"/>
                        <URLImg v-if="item.urlImagenFoto" block class="c-avatar-img" :url="item.urlImagenFoto"/>
                        <UploadNewImgHiddenInput 
                          :api="uploadImg" 
                          :parentId="item.id_Personal"
                          @handler="_function => setValueHandler(_function, item)" />
                        </div>
                      </td>
                  </template>
                  <template #empleado="{item}">
                    <td style="border-top: none;">
                      <div>
                        <h4>{{ item.nombre_Empleado }}</h4>
                      </div>
                      <div>
                        <span>{{ item.identificacion }}</span>
                      </div>
                      <div>
                        <span>{{ personaType[item.tipo_Personal] }}</span>
                      </div>
                      <div v-if="$store.state.user.data.tipo_Empleado === 'A'">
                        <a href="#" 
                          v-c-tooltip="'Agregar imagen'" 
                          @click="(e) => {
                            e.stopPropagation()
                            selectNewAvatar(item)
                          }">
                          <i class="bi bi-image"></i>
                        </a>
                      </div>
                    </td>
                  </template>
                  <template #contacto="{item}">
                    <td class="" style="border-top: none;">
                      <div>
                        <i class="bi bi-phone h5 mr-2"></i>
                        <span>{{ item.celular }}</span>
                      </div>
                      <div>
                        <i class="bi bi-envelope-at h5 mr-2"></i>
                        <CLink 
                          :href="`mailto://${item.correo_Electronico}`"
                          @click="(e) => e.stopPropagation()">
                          {{ item.correo_Electronico }}
                        </CLink>
                      </div>
                      <div>
                        <i class="bi bi-person-badge h5 mr-2"></i>
                        <span>{{ item.cargo }}</span>
                      </div>
                      <div>
                        <i class="bi bi-diagram-3 h5 mr-2"></i>
                        <span>{{ item.grupo_Personal }}</span>
                      </div>
                    </td>
                  </template>
                  <template #informacion="{item}">
                    <td>
                      <div class="d-flex justify-content-end">
                        <i class="bi bi-people mr-2"></i>
                        <span>{{ item.cantidadClientes }}</span>
                      </div>
                    </td>
                  </template>
                  <!-- <template #detalles="{item}">
                    <td style="border-top: none;">
                      v-on:click.stop.prevent="toggleDocument($event, item)"
                      <a                          
                        href="#"
                        class="mb-2 p-2"
                        style="text-decoration: none;"
                        @click="toggleDocument($event, item)">
                        <CIcon class="text-dark" :name="item._toggled ? 'cil-chevron-circle-up-alt' : 'cil-chevron-circle-down-alt'"></CIcon>
                      </a>
                    </td>
                  </template> -->
                  <template #details="{item}">
                    <CCollapse class="my-3" :show="item._toggled">
                      <div class="d-flex justify-content-end">
                          <!-- <CButtonGroup>
                            <CButton color="dark" size="sm" variant="outline">
                              Button
                            </CButton>
                            <CButton color="dark" size="sm" variant="outline">
                              Button
                            </CButton>
                            <CButton color="dark" size="sm" variant="outline">
                              Button
                            </CButton>
                          </CButtonGroup> -->
                          
                          <!-- <quotes-chart v-if="item._toggled" :idQuery="item.id_Personal"/> -->
                      </div>
                    </CCollapse>
                  </template>
                </CDataTable>
                <CPagination
                  size="sm"
                  class="d-flex justify-content-center"
                  :activePage.sync="page"
                  :pages="pageCount"
                  @update:activePage="(value, a) => getData(value, searchWord)"
                /> 
            </CCardBody>
      <LoadingCover v-show="loading" />
    </CCard>
  </CContainer>
</template>

<style scoped>
  .card-gallery {
    display: grid;
    gap: 1rem;
    grid-template-columns: repeat(auto-fit, minmax(min(100%, 15rem), 0.4fr));
  }
  .c-avatar-seller {
      width: 3rem;
      height: 3rem;
  }
</style>

<script>
  import { uuid } from 'vue-uuid'
  import LoadingCover from "@/components/containers/LoadingCover.vue";
  import URLImg from "@/components/containers/URLImg.vue";
  import UploadNewImgHiddenInput from '../../containers/UploadNewImgHiddenInput.vue'
  
  import constants from "@/constants";
  import { errorMessage } from '../../../general'
  import { grabaImagenPersonal } from '../../../api'
  import { dataGridVendedores } from '../../../apiDataGrids'
  // import QuotesChart from '../../containers/QuotesChart.vue'

  const fields = [
    {
      key: 'avatar',
      label: ''
    },
    {
      key: 'empleado',
      label: 'Empleado',
      _style:'text-align:center;'
    },
    {
      key: 'contacto',
      label: 'Contacto',
      _style:'text-align:center;'
    },
    {
      key: 'informacion',
      label: 'Información',
      _style:'text-align:center;'
    }
  ]

  export default {
    data() {
      return {
        uuid,
        fields,
        loading: false,
        page: 1,
        pageCount: 1,
        itemsPerPage: 5,
        searchWord: '',
        sellers: [],
        randomizedAvatars: {},
        personaType: {
          "A": "Administración",
          "C": "Cajero",
          "B": "Bodega",
          "L": "Logística",
          "D": "Director Comercial",
          "V": "Vendedor"
        }
      }
    },
    components: {
      LoadingCover,
      URLImg,
      UploadNewImgHiddenInput
      // QuotesChart
    },
    methods: {
      async getData(page, search) {
        this.loading = true;

        try {
          this.searchWord = search;

          const { count, results } = await dataGridVendedores(this, page, search);

          this.pageCount = parseInt(count / this.itemsPerPage)
          if (this.pageCount < (count / this.itemsPerPage)) {
            this.pageCount++
          }
          this.sellers = results
        } catch (error) {
          this.$store.commit('setAlert', {
            color: "danger",
            message: 'Error al cargar datos',
            show: 5
          })
        } finally{
          this.loading = false
        }
      },
      toggleDocument(e, item){
        e.stopPropagation()
        this.$set(item, '_toggled', !item._toggled)
        // this.$nextTick(() => { })
      },
      goTo(item, destiny){
        this.$store.commit('set', ['selectedSeller', item])

        this.$router.push(
          {
            path: `/empresa/archivo/vendedores/${destiny}`
          }
        )
      },
      async uploadImg(personalId, fileName, base64) {
        try {
          this.loading = true

          await grabaImagenPersonal(
            this,
            personalId,
            "Foto",
            fileName,
            base64
          )
          this.$store.commit(
            'setAlert',
            { 
              color: 'success',
              message: constants.messages.successfulAction,
              show: 5 
            }
          )
        } catch (error) {
          console.log(error);
          this.$store.commit('setAlert', {
            color: "danger",
            message: errorMessage(error),
            show: 5
          })
        } finally {
          this.loading = false
          await this.getData(this.page, this.searchWord)
        }
      },
      selectNewAvatar(item) {
        item._open()
      },
      setValueHandler(_function, item) {
        this.$set(item, '_open', _function)
      },
      pathPhotoFile(itemId) {
        if (this.randomizedAvatars[itemId]) {
          return this.randomizedAvatars[itemId]
        }

        const randomValue = Math.floor(Math.random() * 6) + 1
        this.randomizedAvatars[itemId] = `avatar0${randomValue}.jpg`

        return this.randomizedAvatars[itemId]
      },
      getUrlImg(str) {
        const images = require.context('../../../../public/static/img', false, /\.jpg$/)
    
        return images(`./${str}`)
      }
    },
    mounted() {
      this.getData(this.page)
    }
  }
</script>
